import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc0b5f70&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\WebProject\\桌面\\JY-SSO\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc0b5f70')) {
      api.createRecord('bc0b5f70', component.options)
    } else {
      api.reload('bc0b5f70', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bc0b5f70&", function () {
      api.rerender('bc0b5f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/index.vue"
export default component.exports